import { render } from "./ContactInfo.vue?vue&type=template&id=c83bfdee&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=c83bfdee&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83bfdee"]])

export default __exports__